var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyPredictions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8996_3809)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.07213 39.0939C6.1165 35.2886 5.125 31.1775 5.125 26.875C5.125 19.6964 7.9205 12.9475 12.9965 7.8715C18.0725 2.7955 24.8214 0 32 0C39.1786 0 45.9275 2.7955 51.0035 7.8715C56.0795 12.9475 58.875 19.6964 58.875 26.875C58.875 31.1775 57.8834 35.2886 55.9279 39.0939C54.1329 42.5868 51.5405 45.6959 48.4178 48.114H15.5822C12.4595 45.696 9.86713 42.5868 8.07213 39.0939ZM56.375 62.125V59.375C56.375 56.9588 54.4162 55 52 55H12C9.58375 55 7.625 56.9588 7.625 59.375V62.125C7.625 63.1605 8.4645 64 9.5 64H54.5C55.5355 64 56.375 63.1605 56.375 62.125ZM62 3.125H60.75V1.875C60.75 0.8395 59.9105 0 58.875 0C57.8395 0 57 0.8395 57 1.875V3.125H55.75C54.7145 3.125 53.875 3.9645 53.875 5C53.875 6.0355 54.7145 6.875 55.75 6.875H57V8.125C57 9.1605 57.8395 10 58.875 10C59.9105 10 60.75 9.1605 60.75 8.125V6.875H62C63.0355 6.875 63.875 6.0355 63.875 5C63.875 3.9645 63.0355 3.125 62 3.125ZM8.25 3.125H7V1.875C7 0.8395 6.1605 0 5.125 0C4.0895 0 3.25 0.8395 3.25 1.875V3.125H2C0.9645 3.125 0.125 3.9645 0.125 5C0.125 6.0355 0.9645 6.875 2 6.875H3.25V8.125C3.25 9.1605 4.0895 10 5.125 10C6.1605 10 7 9.1605 7 8.125V6.875H8.25C9.2855 6.875 10.125 6.0355 10.125 5C10.125 3.9645 9.2855 3.125 8.25 3.125Z",
    fill: "url(#paint0_linear_8996_3809)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1993 21.8146C46.9248 22.1487 40.384 30 31.9999 30C23.6157 30 17.0749 22.1487 16.8007 21.8146C16.233 21.1231 16.233 20.127 16.8007 19.4355C17.0749 19.1012 23.6157 11.25 31.9999 11.25C28.8933 11.25 26.3749 13.7684 26.3749 16.875C26.3749 19.9816 28.8933 22.5 31.9999 22.5C35.1065 22.5 37.6249 19.9816 37.6249 16.875C37.6249 13.7684 35.1065 11.25 31.9999 11.25C40.384 11.25 46.9248 19.1013 47.1993 19.4354C47.7668 20.127 47.7668 21.123 47.1993 21.8146ZM25.7499 34.375H24.4999V33.125C24.4999 32.0895 23.6604 31.25 22.6249 31.25C21.5894 31.25 20.7499 32.0895 20.7499 33.125V34.375H19.4999C18.4644 34.375 17.6249 35.2145 17.6249 36.25C17.6249 37.2855 18.4644 38.125 19.4999 38.125H20.7499V39.375C20.7499 40.4105 21.5894 41.25 22.6249 41.25C23.6604 41.25 24.4999 40.4105 24.4999 39.375V38.125H25.7499C26.7854 38.125 27.6249 37.2855 27.6249 36.25C27.6249 35.2145 26.7854 34.375 25.7499 34.375ZM51.9024 55L48.4177 48.114H15.5822L12.0974 55H51.9024Z",
    fill: "url(#paint1_linear_8996_3809)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8996_3809",
    x1: 32,
    y1: 64,
    x2: 32,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7000FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8996_3809",
    x1: 31.9999,
    y1: 55,
    x2: 31.9999,
    y2: 11.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAAAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4F3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8996_3809"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPredictions);
export default __webpack_public_path__ + "static/media/empty-predictions.ce219063bee0721a2f4b321feae08a8c.svg";
export { ForwardRef as ReactComponent };